module.exports = __webpack_public_path__ + "fonts/Benzin-Medium.0f09b44.ttf";